import { InspireITLogo } from '@/components/Icons';
import { useMemo } from 'react';

export const Footer = () => {
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  return (
    <div className="w-full bg-gray-700 py-5 text-white">
      <div className="mx-auto flex max-w-screen-2xl justify-between">
        <InspireITLogo />
        <span className="self-end text-sm font-black">
          © {currentYear} Inspire. Made with 💪 in Almada.
        </span>
      </div>
    </div>
  );
};
